import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import styles from "./App.module.css";

import Header from "./components/Header";

import Home from "./pages/Home";
import Billboards from "./pages/billboards/Billboards";
import Footer from "./components/Footer";
import Admin from "./pages/billboards/admin/Admin";
import Ads from "./pages/ads/Ads";
import Mods from "./pages/mods/Mods";
import TOS from "./pages/tos/tos";
import PrivacyPolicy from "./pages/privacy-policy/PrivacyPolicy";

function App() {
  const [user, setUser] = useState(null);
  const [steedieTokens, setSteedieTokens] = useState(0);
  const [level, setLevel] = useState(1);

  const onBuySuccess = (amount) => {
    setSteedieTokens(steedieTokens - amount);
  };

  const handleSignOut = () => {
    localStorage.removeItem("steedie-user");
    setUser(null);
    window.location.href = "/";
  };

  // can login wherever there's a Header (everywhere), so this
  // useEffect triggers whenever page refreshes and checks urlParams
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const steamId = urlParams.get("steamId");
    const username = urlParams.get("username");
    const avatar = urlParams.get("avatar");
    const adminUi = urlParams.get("adminUi");
    const jwt = urlParams.get("jwt");

    if (steamId && username && avatar && jwt) {
      const userData = { steamId, username, avatar, adminUi, jwt };
      localStorage.setItem("steedie-user", JSON.stringify(userData));
      setUser(userData);
      window.history.replaceState({}, "", "/");
    } else {
      const stored = localStorage.getItem("steedie-user");
      if (stored) setUser(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      if (!user) return;

      const res = await fetch(
        "https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/get-user",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.jwt}`,
          },
        }
      );

      if (res.ok) {
        const data = await res.json();
        //console.log("get-user response data", data);
        setSteedieTokens(data.steedieTokens);
        setLevel(data.level);
      }
    };

    fetchUser();
  }, [user]);

  return (
    <Router>
      <div className={styles.test}>
        <Header
          user={user}
          steedieTokens={steedieTokens}
          level={level}
          handleSignOut={handleSignOut}
        />
        <main>
          <Routes>
            <Route path="/" element={<Home user={user} />} />
            <Route
              path="/billboards"
              element={
                <Billboards
                  user={user}
                  userSteedieTokens={steedieTokens}
                  onBuySuccess={onBuySuccess}
                />
              }
            />
            <Route path="/billboards/admin" element={<Admin user={user} />} />
            <Route path="/ads" element={<Ads />} />
            <Route path="/mods" element={<Mods />} />
            <Route path="/tos" element={<TOS />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
